import { render, staticRenderFns } from "./WhatsappAuditPanel.vue?vue&type=template&id=39b50ba6&scoped=true&lang=pug"
import script from "./WhatsappAuditPanel.vue?vue&type=script&lang=js"
export * from "./WhatsappAuditPanel.vue?vue&type=script&lang=js"
import style0 from "./WhatsappAuditPanel.vue?vue&type=style&index=0&id=39b50ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b50ba6",
  null
  
)

export default component.exports